import styled from 'styled-components'
import { Layout } from 'antd'

const AntLayoutStyled = styled(Layout)``

export default AntLayoutStyled
